<template>
  <div>
    <Notification />
    <div class='header'>
      <h3><span v-if='!loading || count'>{{ count.toLocaleString() }} Users</span></h3>
      <div class='actions'>
        <div>
          <span class="switch-label">Show active users</span>
          <ToggleSwitch :onChange='toggleActivePlans' v-model='activePlan'></ToggleSwitch>
        </div>
        <Dropdown :onChange='filterPlan' v-model='plan' width='175px'>
          <a-select-option title="Plans: All" value="all">All</a-select-option>
          <a-select-option title="Plans: Customer" value="customer">Customer</a-select-option>
          <a-select-option title="Plans: Trial" value="trial">Trial</a-select-option>
        </Dropdown>
        <button class='flat-button new-user' @click='openForm'>New User</button>
        <a-modal class="user-modal" :width='600' :closable='false' :visible="formOpened" :footer='null' @cancel='closeForm' onOk="handleSubmit">
          <NewUserForm />
        </a-modal>
      </div>
    </div>

    <UsersTable />

    <a-modal class="user-modal" v-if='user' :width='600' :closable='false' :visible="editFormOpened" @cancel='closeEditForm' :footer='null' onOk="handleUpdate">
      <EditUserForm />
    </a-modal>
  </div>
</template>

<script>
import Dropdown from '@/components/Dropdown'
import Notification from '@/components/Notification'
import UsersTable from '@/components/users/UsersTable'
import NewUserForm from '@/components/users/NewUserForm'
import EditUserForm from '@/components/users/EditUserForm'
import ToggleSwitch from '@/components/ToggleSwitch'
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'

export default {
  name: 'users',
  components: {
    Dropdown,
    Notification,
    UsersTable,
    NewUserForm,
    EditUserForm,
    ToggleSwitch
  },
  data() {
    return {
      plan: 'all',
      activePlan: false
    }
  },
  methods: {
    ...mapActions('users', ['fetchPage']),
    ...mapMutations('newUserForm', { openForm: 'open', closeForm: 'close' }),
    ...mapMutations('editUserForm', { closeEditForm: 'close'}),
    filterPlan(plan) {
      if(plan === 'all') plan = null
      this.fetchPage({plan, active: this.activePlan})
    },
    toggleActivePlans(active) {
      let plan = (this.plan === 'all' ? null : this.plan)
      this.fetchPage({active, plan})
    },
    handleSubmit(event) {
      this.postUser(this.newUser)
      this.$nextTick(() => { this.$v.$reset() })
    },
    handleUpdate(event) {
      this.updateUser(this.user)
    },
  },

  computed: {
    ...mapState('users', ['count', 'loading']),
    ...mapState('newUserForm', { formOpened: 'opened' }),
    ...mapState('editUserForm', { editFormOpened: 'opened' }),
    ...mapState('editUserForm', ['user']),
    ...mapState('subscriptions', ['subscriptions']),
  }
}
</script>

<style scoped lang='stylus'>
@import '../styles/buttons'

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;

  h3 {
    margin: 0;
  }

  .new-user {
    margin-left: $spacingMd;
  }

  .actions {
    display: flex;
    align-items: center;
    .ant-switch {
      margin-right: 20px;
    }
    
    .switch-label {
      font-weight: 500;
      margin-right: 5px;
    }
  }

  .ant-select {
    margin-left: $spacingMd;
  }
}

</style>

<style lang='stylus'>
  
  .user-modal {
    .ant-modal-body {
      margin-top: 0px;
    }
  }

</style>
